import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {Pay} from 'com/gongxigames/math/core/game/Pay';
import {PayType} from 'com/gongxigames/math/core/game/enums/PayType';
import {KeypadInfoElementsModule} from '@gongxigames/framework/slot/modules/keypadInfo/KeypadInfoElementsModule';
import {KeypadInfoMainGameState} from '@gongxigames/framework/slot/modules/keypadInfo/states/KeypadInfoMainGameState';

export class KeypadInfoFreeSpinsState extends KeypadInfoMainGameState {

    public onEnterState(): void {
        this.view.initializeFreeSpinsLayout();
    }

    protected onReelsSpinningStarted(): void {
        this.module.refreshBalance();

        if (this.module.logic.nextAction === Action.FREESPIN) {
            this.view.refreshFreeSpinsInfo(
                this.module.logic.getFreeGamesTotalCount() - this.module.logic.getFreeGamesCount() + 1,
                this.module.logic.getFreeGamesTotalCount());
        }
        this.setSpinTickerText();
    }

    protected onFreeSpinsOutroStarted(): void {
        super.onFreeSpinsOutroStarted();

        this.module.gotoState(KeypadInfoElementsModule.BASIC_STATE);
    }

    protected onAllReelsStopped(): void {
        this.view.refreshRightTicker('');
    }

    protected onPayAnimation(pay: Pay): void {
        if (pay.type === PayType.SCATTER) {
            this.onScatterPay(pay);
        } else {
            if (pay.type === PayType.LINE) {
                this.setLineWinTickerText(`${pay.lineId + 1}`, pay.win * pay.bet);
            } else {
                if (pay.ways > 0) {
                    this.setWaysWinTickerText(pay.ways, pay.win * pay.bet);
                }
            }
        }
    }

    protected onGamePays(): void {
        if (!this.module.isRetriggerFreeGames) {
            const str = this.module.languageService.get('freeGamePay',
                {win: this.module.currencyFormatter.formatCents(this.module.logic.getWin())});

            this.view.refreshLeftTicker(str);
        }
    }
}
